<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.bonus.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="bonus">
          <b-carousel
            :indicator="true"
            :indicator-inside="true"
            :indicator-mode="'hover'"
            :indicator-style="'is-lines'"
            :pause-hover="true"
            :pause-info="false"
          >
            <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
              <div class="card">
                <div class="card-image">
                  <figure class="image">
                    <img :src="url + carousel.image" />
                  </figure>
                </div>
                <div class="card-content">
                  <div class="content">
                    <div v-html="carousel.html"></div>
                  </div>
                </div>
              </div>
            </b-carousel-item>
          </b-carousel>
          <div class="description">
            <div class="m-b-30" v-if="notice" v-html="notice"></div>
          </div>
        </div>
        <div
          v-if="
            selectedBonus.userBonus._id &&
              selectedBonus.userBonus.isActive === true
          "
        >
          <div class="box-button m-t-30">
            <button class="button full-100 is-primary" @click="closeModal">
              {{ $t('modals.confirmBtn') }}
            </button>
          </div>
        </div>
        <div v-else>
          <div class="box-button m-t-30">
            <button class="button full-100 is-primary" @click="handleActivate">
              {{ $t('modals.bonus.receiveBtn') }}
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiLookup from '@/api/lookup'
import apiBonus from '@/api/bonus'
import i18n from '../../../../language'

export default {
  name: 'ModalBonus',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    selectedBonus: {
      type: Object
    }
  },
  data() {
    return {
      account: {},
      notice: '',
      url: process.env.VUE_APP_BASE_API,
      carousels: []
    }
  },
  mounted() {
    this.lookupNotice()
  },
  methods: {
    async lookupNotice() {
      let loading = this.$loading.show()

      this.carousels = this.selectedBonus.banners
      setTimeout(async () => {
        try {
          const data = await apiLookup.lookupNotice()

          if (data.notice) {
            this.notice = data.notice.replace(
              /%percentFail%/g,
              this.selectedBonus.percentFail
            )
          }

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    closeModal() {
      this.$emit('closeModal', { isSaved: false })
    },
    handleActivate() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const userBonus = await apiBonus.activateBonus(
            this.selectedBonus.code
          )
          if (userBonus) {
            this.selectedBonus.userBonus = userBonus

            this.$emit('closeModal', { isSaved: true })
            this.showSuccessAlert()
          }
        } catch (error) {
          this.showErrorAlert(error)
        } finally {
          loading.hide()
        }
      }, 200)
    },
    showSuccessAlert() {
      this.$swal(
        i18n.t('modals.successMsg'),
        i18n.t('modals.savedMsg'),
        'success'
      )
    },
    showErrorAlert(text) {
      this.$swal(i18n.t('modals.errorMsg'), text, 'error')
    }
  }
}
</script>

<style scoped lang="scss">
img {
  width: auto;
  height: 60px;
  margin-top: 20px;
  display: block;
  margin: 0 auto;
}

.modal-card-body {
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
}

.bonus {
  position: relative;
  border-radius: 10px;
  width: 100%;
  text-align: center;
  display: block;
  padding: 10px;
  margin-bottom: 20px;

  img {
    width: auto;
    height: 300px;
  }

  .description {
    margin-top: 30px;
    text-align: left;
    color: black;
  }
}
</style>
